'use client';

import { usePathname } from 'next/navigation';
import { useAuthTransition } from '@/lib/auth/auth-transition';
import styles from './transition-logo.module.css';

const AUTH_PATHS = [
  '/login',
  '/sso',
  '/forgot-password',
  '/change-password',
  '/auth/sso',
  '/auth/forgot-password',
  '/auth/change-password',
];

/**
 * Shared brand logo shown top-left on auth routes and during login/logout
 * transitions — mirrors the Angular app.component `showSharedLogo()` /
 * `.transition-logo` (visible when phase !== idle OR the route is an auth page).
 */
export function TransitionLogo() {
  const { phase } = useAuthTransition();
  const pathname = usePathname();

  const onAuthRoute = AUTH_PATHS.some(
    (p) => pathname === p || (pathname?.startsWith(`${p}/`) ?? false),
  );
  const show = phase !== 'idle' || onAuthRoute;
  if (!show) return null;

  const className = [
    styles.transitionLogo,
    phase === 'navigating' ? styles.isNavigating : null,
    phase === 'logout-exiting' ? styles.isLoggingOut : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} aria-hidden="true">
      <span className={styles.transitionLogoSpacer} />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/web-static/assets/images/logo/logo-long-black.svg" alt="" />
    </div>
  );
}
